import { Button } from "@compass/core";
import DnsIcon from '@mui/icons-material/Dns';
import Tooltip from '@mui/material/Tooltip';

interface ManageButtonProps {
    onClick: () => void;
}

export const ManageButton = ({ onClick }: ManageButtonProps) => {
    return (
        <Tooltip title="Manage your dashboard tabs and cards">
            <Button
                variant="contained"
                startIcon={<DnsIcon />}
                onClick={onClick}
                aria-label="Manage dashboard"
            >
                Manage Dashboard
            </Button>
        </Tooltip>
    );
};